import React from "react";
import { useAtomValue } from "jotai";
import ModalComplete from "@components/ModalComplete";
import { modalState } from "@stores/modal";
const ModalContainer = () => {
  const alert = useAtomValue(modalState);
  return alert.show && <ModalComplete />;
};

export default ModalContainer;
